import { BOTTOM_BAR_AIRHELP_PLUS_GTM, BOTTOM_BAR_CHECK_COMPENSATION_GTM } from "modules/common/trackingConsts";
import getPageUrl from "utils/getPageUrl";
import { trackEvents } from "utils/trackingUtils";
import type { LanguageCode } from "config/languages";
import type { StickyBottomBarProps } from "../StickyBottomBar.d";

const getCTAElementProps = (language: LanguageCode, variant: StickyBottomBarProps["variant"]) => {
  if (variant === "ahPlus") {
    return {
      href: getPageUrl(language, "airhelpPlus"),
      onClick: () =>
        trackEvents({
          gtmEvent: BOTTOM_BAR_AIRHELP_PLUS_GTM,
          mixpanelEvent: undefined,
        }),
    };
  }
  return {
    href: getPageUrl(language, "webappNewClaim"),
    target: "_blank",
    onClick: () =>
      trackEvents({
        gtmEvent: BOTTOM_BAR_CHECK_COMPENSATION_GTM,
        mixpanelEvent: undefined,
      }),
  };
};

export { getCTAElementProps };
